// extracted by mini-css-extract-plugin
export var contact = "footer-module--contact--07977";
export var footer = "footer-module--footer--675c6";
export var icon = "footer-module--icon--a26cf";
export var inner = "footer-module--inner--9a309";